import React from 'react';
// Material-UI
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import useAppProvider from 'providers/useAppProvider';
// import Checkbox from '@material-ui/core/Checkbox';

const CustomCheckbox = ({
  id = null,
  size = 'small',
  disabled = false,
  style = null,
  className = null,
  label = 'Select',
  name = 'radioButton',
  value = '',
  checked = false,
  onChange = undefined,
  icon = null,
  iconStyle = {},
  noLabel = false,
}) => {
  const { buttonColor, buttonBorderColor } = useAppProvider();
  return (
    <>
      <FormControlLabel
        className={className}
        value={value}
        name={name}
        control={
          <Radio
            id={id}
            checked={checked}
            onChange={onChange}
            size={size}
            style={{ color: buttonColor || buttonBorderColor }}
          />
        }
        // control={<Checkbox checked={checked} onChange={onChange} inputProps={{ 'aria-label': 'primary checkbox' }} />}
        label={!noLabel ? label : ''}
        disabled={disabled}
        style={{ ...style }}
      />
      <span style={iconStyle}>{icon}</span>
    </>
  );
};

export default CustomCheckbox;
